import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BlogCardGrid from "../../design-system/templates/blog-card-grid"
import ExternalLinks from "../../external-links"

export default function BlogFeatures(props) {
  const query = useStaticQuery(graphql`
    query {
      resourcesFade: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/resources_title.svg"
        }
      ) {
        publicURL
      }
      blogCMS: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/blog/desktop blog image 01.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 750) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogCreate: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/blog/desktop blog image 02.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 750) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogDesign: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/blog/desktop blog image 03.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 750) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const blogCardDetails = [
    {
      fluidImage: query.blogCMS.childImageSharp.fluid,
      title: "Product 101: Mappedin CMS",
      resourceName: "Blog",
      description:
        "The backend tool that powers it all - read about the Mappedin CMS, its functionality, and why it was created.",
      link: ExternalLinks.hubspot.product101CMS,
    },
    {
      fluidImage: query.blogCreate.childImageSharp.fluid,
      title: "How to Create Indoor Maps With Mappedin",
      resourceName: "Blog",
      description:
        "Indoor digital maps are extremely important when it comes to navigating indoor spaces where GPS doesn’t work.",
      link: ExternalLinks.hubspot.createMaps,
    },
    {
      fluidImage: query.blogDesign.childImageSharp.fluid,
      title: "Designing Indoor Maps for Different Use Cases",
      resourceName: "Blog",
      description:
        "At Mappedin, we are passionate about indoor navigation, design, and building the best-in-class maps for all industries.",
      link: ExternalLinks.hubspot.designMaps,
    },
  ]

  return (
    <>
      <BlogCardGrid
        title="Learn More About Our Mapping Products"
        blogCardDetails={blogCardDetails}
      />
    </>
  )
}
